import { queryOptions, useQuery } from '@tanstack/react-query';
import { getMe } from '@linkie/api-client';
const getMeQueryOptions = () => {
    return queryOptions({
        queryKey: ['me'],
        queryFn: () => getMe(),
    });
};
const useGetMe = ({ queryConfig } = {}) => {
    return useQuery(Object.assign(Object.assign({}, getMeQueryOptions()), queryConfig));
};
export default useGetMe;
//# sourceMappingURL=useGetMe.hook.js.map